import { ANumberResponse } from '@sales/modules/subscription/models/available-numbers-response.model';

export class PhoneNumber {
  isPortingOrder: boolean;
  activationDateTime: Date;
  isEarliestPortingDate: boolean;
  portingTime: string;
  isOwnerChange: boolean;
  keepExistingSim: boolean;
  existingOwnerCustomerId: string;
  aNumber: string;
  icc: string;
  orderSim: boolean;
  isESim: boolean;
  availableNumbers: ANumberResponse;
  eid?: string;
}
